import React, { createElement } from 'react';
import { AdvertorialPage } from './pages/AdvertorialPage';
declare global {
  interface Window {
    edgetag: any;
  }
}
// EdgeTag initialization - exact match to Blotout snippet
;
(function () {
  const edgeURL = 'https://fzikz.topwellnessreviews.com';
  !function (u: string) {
    window.edgetag = window.edgetag || function () {
      ;
      (window.edgetag.stubs = window.edgetag.stubs || []).push(arguments);
    };
    const t = document.createElement('script');
    t.type = 'text/javascript';
    t.src = u;
    t.async = true;
    const e = document.getElementsByTagName('script')[0];
    if (e && e.parentNode) {
      e.parentNode.insertBefore(t, e);
    } else {
      document.head.appendChild(t);
    }
  }(`${edgeURL}/load`);
  !function () {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const userId = params.get('et_u_id') || '';
    window.edgetag('init', {
      edgeURL,
      disableConsentCheck: true,
      userId
    });
  }();
  window.edgetag('tag', 'PageView');
})();
export function App() {
  return <AdvertorialPage data-id="element-0" />;
}